import React from 'react';
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import routes from "routes.jsx";
import Sidebar from 'components/Sidebar/Sidebar.jsx';
import { useSidebar } from 'contexts/SidebarContextProvider';
import "../css/layouts/Workflow.css";

const Workflow = (props) => {
    const mainContent = React.useRef(null);
    const location = useLocation();
    const { isOpen, closeSidebar } = useSidebar();
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1024);

    React.useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainContent.current.scrollTop = 0;
    }, [location]);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/workflow") {
                return (
                    <Route path={prop.path} element={prop.component} key={key} exact />
                );
            } else {
                return null;
            }
        });
    };

    return (
        <div className="workflow-container">
            <Sidebar />

            <div className="content-container" style={{ backgroundColor: "#3D393B", height: '100vh' }}>
                {isOpen && isMobile && (
                    <div
                        className="blocking-overlay"
                        onClick={closeSidebar}
                    />
                )}

                <div
                    ref={mainContent}
                    className={isOpen ? "workflow-main-content" : "workflow-main-content-closed-bar"}
                >
                    <Routes>
                        {getRoutes(routes)}
                        <Route path="*" element={<Navigate to="/workflow/index" replace />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default Workflow;
